import Alpine from "alpinejs";

import collapse from '@alpinejs/collapse';
import intersect from '@alpinejs/intersect';
import focus from '@alpinejs/focus';

// 1st party plugins
Alpine.plugin(collapse);
Alpine.plugin(intersect);
Alpine.plugin(focus);

import freeform from "./freeform";
import headroom from "./headroom";
import megamenu from "./megamenu";
import mobileNav from "./mobileNav";
import { search } from "./search";
import { salesRepSearch } from "./salesRepSearch";
import { salesRepMap } from "./salesRepMap";
import sprig from "./sprig";
import swiper from "./swiper";
import { teamBio } from "./teamBio";
import { teamAccordion } from "./teamAccordion";
import { productFinishModal } from "./productFinishModal";
import typicalModal from "./typicalModal";

// Components
Alpine.data('freeform', freeform);
Alpine.data("headroom", headroom);
Alpine.data("megamenu", megamenu);
Alpine.data("mobileNav", mobileNav);
Alpine.data("search", search);
Alpine.data("salesRepSearch", salesRepSearch);
Alpine.data("salesRepMap", salesRepMap);
Alpine.data("sprig", sprig);
Alpine.data("swiper", swiper);
Alpine.data("teamBio", teamBio);
Alpine.data("teamAccordion", teamAccordion);
Alpine.data("productFinishModal", productFinishModal);
Alpine.data("typicalModal", typicalModal);

window.Alpine = Alpine;
Alpine.start();
